export const STUDIES = [
    {
        slug: "adocao-ia-90-dias",
        title: "Como iniciar a adoção de IA em 90 dias",
        description: "Um roteiro prático para escolher o primeiro caso, estruturar o piloto, medir valor e preparar a expansão.",
        tag: "Guia executivo",
        file: "/assets/studies/zild-adocao-ia-90-dias.pdf",
    },
    {
        slug: "checklist-governanca-ia",
        title: "Checklist de governança e segurança para IA",
        description: "Controles essenciais para dados, acessos, agentes, modelos, auditoria, ModelOps e FinOps.",
        tag: "Checklist",
        file: "/assets/studies/zild-checklist-governanca-ia.pdf",
    },
    {
        slug: "custo-real-ia",
        title: "Como calcular o custo real da IA na empresa",
        description: "Um modelo para comparar licenças por usuário, consumo, implantação e custo operacional.",
        tag: "Guia financeiro",
        file: "/assets/studies/zild-custo-real-ia.pdf",
    },
];
